<template>
  <form @submit.prevent="submitForm">
    <div>
      <label>Name</label>
      <input type="text" placeholder="Name (required)" v-model="name" />
    </div>
    <div>
      <label>Comment</label>
      <textarea
        placeholder="Comment (no html/bbcode)"
        v-model="text"
      ></textarea>
    </div>
    <button>Add Comment</button>
  </form>
</template>

<script>
import { createPostComment } from "../firestoreHelper.js";

export default {
  name: "CommentForm",
  props: ["postNameUrl"],
  data() {
    return {
      name: "",
      text: "",
    };
  },
  methods: {
    submitForm() {
      if (this.name && this.text) {
        createPostComment(this.postNameUrl, this.name, this.text).then(
          (comment) => {
            this.$emit("comment-added", comment);
          }
        );
      }
    },
  },
};
</script>

<style scoped>
</style>
